module.exports = __webpack_public_path__ + "img/software-mobile.117e0b9d.png";